import logo from '../assets/logo.jpg';

export const LOGO = logo;

// APIs
// export const API_BASE_URL = "https://orisoftpl.com/backend/api/";
export const API_BASE_URL = "https://orisoftpl.com/backend/api";
// export const API_BASE_URL = "https://orisoftpl.com/mandapbooking/api";

// export const FRONTEND_API_BASE_URL =
//     "https://orisoftpl.com/backend/api";


// =========================
// DASHBOARD
// =========================
export const BOOKING_TABLE_URL =
    `${API_BASE_URL}/admin/dashboard`;

export const BOOKING_TABLE_STATUS_URL =
    `${API_BASE_URL}/admin/booking/status-change`;

// =========================
// FRONTEND
// =========================
export const MANDAP_ID_PURPOSE_URL =
    `${API_BASE_URL}/frontend/home`;

// =========================
// COMMON
// =========================
export const CHECK_MOBILE_URL =
    `${API_BASE_URL}/admin/check-mobile`;

// =========================
// SETTINGS
// =========================
export const SETTING_FETCH_URL =
    `${API_BASE_URL}/admin/settings`;

export const SETTING_UPDATE_URL =
    `${API_BASE_URL}/admin/settings`;

// =========================
// ACCOUNT INFO
// =========================
export const ACCOUNT_INFO_FETCH_URL =
    `${API_BASE_URL}/admin/account-info`;

export const ACCOUNT_INFO_PAYMENT_RETURN_URL =
    `${API_BASE_URL}/admin/account-info/payment-return`;

// =========================
// USERS
// =========================
export const USER_FETCH_URL =
    `${API_BASE_URL}/admin/users`;

export const USER_CREATE_URL =
    `${API_BASE_URL}/admin/users`;

export const USER_DELETE_URL = (id) =>
    `${API_BASE_URL}/admin/users/${id}`;

export const USER_EDIT_URL = (id) =>
    `${API_BASE_URL}/admin/users/${id}`;

export const USER_UPDATE_URL = (id) =>
    `${API_BASE_URL}/admin/users/${id}`;

// =========================
// BOOKINGS
// =========================
export const BOOKING_DATA_INSERT_ADMIN_URL =
    `${API_BASE_URL}/admin/bookings`;

// =========================
// MANDAPS
// =========================
export const MANDAP_DATA_INSERT_ADMIN_URL =
    `${API_BASE_URL}/admin/mandaps`;

export const MANDAP_DATA_EDIT_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/mandaps/${id}`;

export const MANDAP_DATA_UPDATE_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/mandaps/${id}`;

// =========================
// PURPOSES
// =========================

export const PURPOSE_DATA_FETCH_ADMIN_URL =
    `${API_BASE_URL}/admin/purposes`;

export const PURPOSE_DATA_INSERT_ADMIN_URL =
    `${API_BASE_URL}/admin/purposes`;

export const PURPOSE_DATA_EDIT_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/purposes/${id}`;

export const PURPOSE_DATA_UPDATE_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/purposes/${id}`;

// =========================
// FAQ
// =========================

export const FAQ_DATA_FETCH_ADMIN_URL =
    `${API_BASE_URL}/admin/faq`;

export const FAQ_DATA_EDIT_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/faq/${id}`;

export const FAQ_DATA_UPDATE_ADMIN_URL = (id) =>
    `${API_BASE_URL}/admin/faq/${id}`;

// =========================
// FRONTEND APIs
// =========================

export const FRONTEND_HOME_URL =
    `${API_BASE_URL}/frontend/home`;

export const FRONTEND_CALENDAR_URL =
    `${API_BASE_URL}/frontend/calendar`;

export const FRONTEND_FAQ_URL =
    `${API_BASE_URL}/frontend/faq`;